export default __webpack_public_path__ + "static/media/notebookCores.c69f20ac.png";